import React, {useState, useRef, useEffect} from 'react';
import ReactPlayer from 'react-player'

const VideoPlayer = ({input}) => {
  const [height, setHeight] = useState();
  const [status, setStatus] = useState({
    mute: true,
    playing: true
  })
// console.log(input)
  const player = useRef()

  useEffect(() => {
    _onResize()
  }, [])

  const _onResize = () => {
    // const headerHeight = document.querySelector("header").getBoundingClientRect()
    // console.log(document.querySelector("header"))
    // console.log(headerHeight)
  }

  const config = {
    youtube: {
      playerVars: {
        controls: 0,
        disablekb: 1,
        enablejsapi: 1,
        iv_load_policy: 3,
        modestbranding: 1,
        showinfo: 0,
        cc_load_policy: 0,
        modestbranding: 1,
        showinfo: 0,
        rel: 0,
        origin: 'https://effective.fr'
      }
    },
    vimeo: {
      title: false,
      background: true,
      controls: false
    }
  }

  const _onReady = () => {}
  const _onEnded = () => {}
  console.log(config)
  return (
    <div className="video-player " ref={player}>
      <ReactPlayer
        className={`player w100 `}
        url={input}
        // url="https://vimeo.com/78429727"
        // playing={status.playing}
        playing={status.playing}
        loop={true}
        muted={status.mute}
        playsinline
        config={config}
        width="100%"
        // height="100%"
        onReady={_onReady}
        onEnded={_onEnded}
      />
    </div>
  );
};

export default VideoPlayer;